// Module-level auth snapshot — bridges React AuthContext to the router's
// beforeLoad (which runs OUTSIDE React and can't call useAuth; the session is
// an HttpOnly cookie JS can't read directly).
//
// Race-free: AuthProvider blocks rendering (including RouterProvider) until the
// GET /me hydration completes, and writes this snapshot before rendering its
// children — so any beforeLoad runs with a current value.

export const authStore = { isAuthenticated: false, cacheIdentity: null as string | null };

/**
 * Session-presence gate for route beforeLoad (Phase 0.5 — session only).
 *
 * requireScope() seam: the later authz wave extends this with the 5-type role +
 * project-membership checks. clientAccessTier is now enforced (row 8.11,
 * VW-BATCH-20260705-AUTHZ-01) — NOT here, though: it's a binary gate in
 * SubAppPage.tsx (the single choke point for all sub-app routes, reusing its
 * existing mountLevels-denial pattern), backed by the real enforcement in
 * workspace_backend/app/authz/manifest_tier.py. Project-membership + the 5-tier
 * granular version (row 8.12) remain future work (see batch CFR).
 */
export function hasSession(): boolean {
  return authStore.isAuthenticated;
}
